export const ROLES = ['Admin', 'Bookkeeper', 'Reports-only', 'Time-only', 'Custom'];
export const INVITATION_STATUSES = ['pending', 'accepted', 'revoked', 'expired'];
export const AUDIT_EVENT_TYPES = [
    // auth
    'auth.login',
    'auth.login_failed',
    'auth.logout',
    'auth.account_locked',
    'auth.mfa_enrolled',
    'auth.mfa_failed',
    'auth.password_changed',
    'auth.magic_link_sent',
    // org
    'org.created',
    'org.member_invited',
    'org.member_joined',
    'org.member_role_changed',
    'org.member_removed',
    'org.invitation_revoked',
    'org.invitation_resent',
    'org.invitation_expired',
    // org config (Phase 3)
    'org.fiscal_config_set',
    'org.timezone_set',
    'org.logo_set',
    // bookkeeping (Wave 1 Phase 1)
    'account.created',
    'customer.created',
    'customer.updated',
    'customer.deleted',
    'vendor.created',
    'vendor.updated',
    'vendor.deleted',
    'item.created',
    'item.updated',
    'item.deleted',
    'je.created',
    'je.updated',
    // sales (Wave 1 Phase 2)
    'tax_rate.created',
    'tax_rate.updated',
    'tax_rate.deleted',
    'withholding_rate.created',
    'withholding_rate.updated',
    'withholding_rate.deleted',
    'invoice.created',
    'invoice.updated',
    'invoice.voided',
    'sales_receipt.created',
    'sales_receipt.updated',
    'sales_receipt.voided',
    'receive_payment.created',
    'receive_payment.updated',
    'receive_payment.voided',
    // purchases (Wave 1 Phase 3)
    'bill.created',
    'bill.updated',
    'bill.voided',
    'expense.created',
    'expense.updated',
    'expense.voided',
    'pay_bill.created',
    'pay_bill.updated',
    'pay_bill.voided',
    // inventory (Wave 1 Phase 4a)
    'inventory.warehouse_created',
    'inventory.warehouse_updated',
    'inventory.warehouse_deactivated',
    'inventory.adjustment_created',
    'inventory.adjustment_voided',
    'inventory.opening_balance_created',
    'inventory.item_type_changed',
    'inventory.stock_negative',
    'inventory.stock_movement_recorded',
    'inventory.layer_consumed',
    'inventory.je_extended_with_cogs',
    'inventory.bill_routed_to_inventory',
    // tx completion (Wave 2 Phase 5a)
    'check.created',
    'check.updated',
    'check.voided',
    'credit_memo.created',
    'credit_memo.updated',
    'credit_memo.applied',
    'credit_memo.voided',
    // SRI signing (Wave 2 Phase 5d)
    'sri.certificate_uploaded',
    'sri.certificate_deactivated',
    'invoice.signed',
    'credit_memo.signed',
    'withholding_receipt.created',
    'withholding_receipt.signed',
    'sri.submitted',
    'sri.received',
    'sri.authorized',
    'sri.rejected',
    'sri.contingencia_emitted',
    'sri.email_queued',
    // multi-establishment (Wave 3 Phase 6)
    'emission_point.created',
    'emission_point.updated',
    'emission_point.set_default',
    'emission_point.deactivated',
    // nota de débito (SRI 05)
    'nota_debito.created',
    'nota_debito.signed',
    'nota_debito.submitted',
    'nota_debito.voided',
    // liquidación de compra (SRI 03)
    'liquidacion_compra.created',
    'liquidacion_compra.signed',
    'liquidacion_compra.submitted',
    'liquidacion_compra.voided',
    // guía de remisión (SRI 06)
    'guia_remision.created',
    'guia_remision.signed',
    'guia_remision.submitted',
    'guia_remision.voided',
    // banking (phase A — statement import)
    'bank_import.completed',
    'bank_transaction.excluded',
    'bank_transaction.restored',
    'bank_transaction.matched',
    'bank_transaction.unmatched',
    'bank_transaction.expense_created',
    'bank_rule.created',
    'bank_rule.updated',
    'bank_rule.deleted',
    'bank_reconciliation.started',
    'bank_reconciliation.completed',
    'bank_reconciliation.undone',
    // system
    'email.send_failed',
];
/**
 * Sentinel orgId used for auth-level events (login, logout, password_changed,
 * account_locked, etc.) that are not scoped to a specific organization.
 * These rows are still part of the immutable audit_event chain, but live
 * in their own per-actor "global" chain rather than per-org.
 */
export const GLOBAL_ORG_ID = '_global';
export const SUBJECTS = [
    'Organization',
    'Member',
    'Invitation',
    'AuditLog',
    'User',
    'Account',
    'Customer',
    'Vendor',
    'Item',
    'JournalEntry',
    'TaxRate',
    'WithholdingRate',
    'Invoice',
    'SalesReceipt',
    'ReceivePayment',
    'Warehouse',
    'InventoryAdjustment',
    'StockMovement',
    'StockBalance',
    'StockLayer',
];
export const ACTIONS = ['manage', 'create', 'read', 'update', 'delete'];
export const LANGS = ['es', 'en'];
//# sourceMappingURL=auth-types.js.map